import Vue from 'vue'

const resource = 'logs'

const post = (pmcCd, calledAppName) => Vue.axios.post(`${resource}/save`, {pmc_cd: pmcCd, called_app_name: calledAppName})

export default {
  post,
}



// WEBPACK FOOTER //
// ./src/api/log.js